import { FC } from 'react';
import { PopupStateProps, RichTextEditor, Tooltip } from '@silverfort/sf-components';
import { Entity } from '../../../../../api';
import { RecipientType, SendEnrollmentEmailPopupState } from '../types';

type PreviewEmailPopupProps = {
    from: string;
} & PopupStateProps<SendEnrollmentEmailPopupState>;

const getRecipientTo = (selectedRecipientType: RecipientType, selectedEntities?: Entity[]): string => {
    if (selectedRecipientType === 'unpaired') {
        return 'Unpaired users';
    }
    if (selectedRecipientType === 'groupOU' && selectedEntities) {
        return selectedEntities.map((entity) => entity.name).join(', ');
    }

    return '';
};

const PreviewEmailContent: FC<PreviewEmailPopupProps> = ({ from, popupState }) => {
    const { selectedEntities, formValues } = popupState;
    const to = getRecipientTo(formValues.recipientType, selectedEntities);

    return (
        <div className="flex flex-1 flex-col h-full gap-8">
            <div className="rounded-[8px] border border-sf-gray-100 grid grid-cols-[54px] grid-rows-3 gap-y-4 gap-x-6 text-14 font-medium p-6">
                <div className="text-sf-gray-400">From:</div>
                <div className="col-span-2">{from}</div>
                <div className="row-start-2 text-sf-gray-400">To:</div>
                <Tooltip title={to} className="col-span-2 row-start-2 truncate">
                    <div className="col-span-2 row-start-2">{to}</div>
                </Tooltip>
                <div className="row-start-3 text-sf-gray-400">Subject:</div>
                <div className="col-span-2 row-start-3">{formValues.subject}</div>
            </div>

            <div className="border border-sf-gray-100 rounded-[8px] h-full">
                <div className="h-[54px] py-4 flex items-center justify-center border-b border-sf-gray-100">
                    <img style={{ maxHeight: 22 }} alt="companyLogoUrl" src={popupState.formValues.companyLogoUrl} />
                </div>
                <div className="p-4">
                    <RichTextEditor
                        value={formValues.content}
                        tokenProps={{
                            list: ['{user-name}', '{company-name}', '{company-email-domain}'],
                            color: '#A5A5A5'
                        }}
                        mode="view"
                        contentClassName="border-0 [&&]:shadow-none"
                    />
                </div>
            </div>
        </div>
    );
};

export default PreviewEmailContent;
